import React, { useState, useEffect } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
import Snackbar from '../UI/Snackbar'
import TerrainIcon from '@material-ui/icons/TerrainRounded'
import CreateOrEditHaul from './CreateOrEditHaul'
import ViewHaul from './ViewHaul'
import HaulItem from './HaulItem'
import { usePitslipActionModal } from './Shared/hooks'
import UploadBackupModal from './UploadBackupModal'
import { api } from '../Controllers/api'
import MaterialsModal from '../Materials/MaterialsModal'
import { getHauls, createNewHaul, editHaul } from './Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import { getMaterials, toggleMaterialsModal } from '../Materials/Store/actions'
import SmConfirmModal from '../UI/SmConfirmModal'
import TableTopSection from 'UI/TableTopSection'
import { getToken } from 'Companies/Store/actions'

const Hauls = props => {
  const [haulsList, setHaulsList] = useState(props.hauls.haulList)
  const [createOrEditHaulModal, setCreateOrEditHaulModal] = useState(false)
  const [pitSlipUpload, setPitSlipUpload] = useState([])
  const [uploadBackupModal, setUploadBackupModal] = useState(false)
  const [uploadBackupHaulId, setUploadBackupHaulId] = useState()
  const [viewHaulModal, setViewHaulModal] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [searchFilter, setSearchFilter] = useState(false)
  const { pitslipActionModal, handlePitslipActionModal } = usePitslipActionModal()
  const [modalFunction, setModalFunction] = useState() // edit, new, view
  const [currentHaul, setCurrentHaul] = useState()
  const [viewStep, setViewStep] = useState(0) //0, 1, 2
  const [confirmModal, setConfirmModal] = useState(false)
  const [handleSubmit, setHandleSubmit] = useState()
  const [procoreCostCodes, setProcoreCostCodes] = useState()

  useEffect(() => {
    if (props.companyFeatures.includes('procore')) {
      props.getToken()
    }
  }, [props.companyFeatures])

  const getProcoreCostCodes = () => {
    if (props.procore && props.procore.authToken) {
      api.post(`procore/get-cost-codes`, { token: props.procore.authToken }).then(({ data }) => {
        setProcoreCostCodes(data)
      })
    }
  }

  useEffect(() => {
    if (props.procore && props.procore.authToken) {
      getProcoreCostCodes()
    }
  }, [props.procore])

  const createNewHaul = values => {
    createOrEditHaulModalToggle()
    props.createNewHaul(values)
    showSnackBar()
  }

  const editHaul = values => {
    props.editHaul(values)
    createOrEditHaulModalToggle()
    confirmModalToggle()
  }

  const showConfirmEditModal = handleSubmit => {
    setHandleSubmit(() => handleSubmit)
    confirmModalToggle()
  }

  const handleModalFunction = func => {
    setModalFunction(func)
  }

  const confirmModalToggle = () => {
    setConfirmModal(!confirmModal)
  }

  const createOrEditHaulModalToggle = (type, _id) => {
    if (createOrEditHaulModal) {
      return setCreateOrEditHaulModal(false)
    }
    if (_id) {
      const haul = haulsList.find(haul => haul._id === _id)
      setCurrentHaul(haul)
    }
    getProcoreCostCodes()
    handleModalFunction(type)
    setCreateOrEditHaulModal(true)
  }

  const showSnackBar = () => {
    props.toggleSnackBar(true)
    setTimeout(() => {
      props.toggleSnackBar(false)
    }, 2500)
  }

  const haulDetailModalToggle = (_id, step) => {
    if (viewHaulModal) {
      return setViewHaulModal(false)
    }
    const haulDetails = haulsList.find(haul => haul._id === _id)
    handleModalFunction('view')
    setCurrentHaul(haulDetails)
    setViewHaulModal(true)
  }

  const uploadBackupModalToggle = id => {
    setUploadBackupHaulId(id)
    setPitSlipUpload([])
    setUploadBackupModal(!uploadBackupModal)
  }

  // const checkMimeType = event => {
  //   let files = event.target.files
  //   let err = ''
  //   // list allow file type
  //   const types = ['image/png', 'image/jpeg', 'image/gif']
  //   for (i = 0; i < files.length; i++) {
  //     if (types.every(type => files[x].type !== type)) {
  //       err += files[x].type + ' is not a supported format\n'
  //     }
  //   }
  //   if (err !== '') {
  //     event.target.value = null
  //     console.log(err)
  //     return false
  //   }
  //   return true
  // }

  // const fileChange = e => {
  //   console.log(e.target.files)
  //   // if (checkMimeType(event)) {
  //   setPitSlipUpload(e.target.files[0])
  //   // }
  // }

  const fileChangeDrop = file => {
    setPitSlipUpload([...pitSlipUpload, file])
  }

  const fileStatusChange = file => {
    setPitSlipUpload([...pitSlipUpload, file])
  }

  const uploadPitSlip = _id => {
    const data = new FormData()
    const haulDetails = haulsList.find(haul => haul._id === _id)
    const distinctFiles = [...new Set(pitSlipUpload.map(file => file.file))]
    distinctFiles.map(file => data.append(`file`, file))
    data.append('haulDetails', JSON.stringify(haulDetails))
    api
      .post(`addslip`, data, {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      })
      .then(() => {
        setPitSlipUpload([])
        handlePitslipActionModal()
        uploadBackupModalToggle()
      })
      .catch(() => alert('Error uploading'))
  }

  const search = e => {
    e.preventDefault()
    props.history.push(`/app/hauls?search=${searchValue}`)
    setSearchedValue(searchValue)

    let searchList = []
    if (searchValue.length === 0) {
      props.history.push(`/app/hauls`)
      setSearchFilter(false)
      setHaulsList(setHaulsList)
      return
    }
    //eslint-disable-next-line
    props.hauls.haulList.map(item => {
      if (
        item.haulId.toLowerCase().search(searchValue.toLowerCase()) !== -1 ||
        item.project.projectName.toLowerCase().search(searchValue.toLowerCase()) !== -1
      ) {
        searchList = searchList.concat(item)
      }
    })
    setHaulsList(searchList)
    setSearchFilter(true)
  }

  const clearSearch = () => {
    setSearchValue('')
    setSearchedValue('')
    props.history.push(`/app/hauls`)
    setHaulsList(props.hauls.haulList)
    setSearchFilter(false)
  }

  useEffect(() => {
    props.getHauls(true)
    props.getMaterials(true)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.hauls.haulList && searchValue === '' && searchedValue === '') {
      setHaulsList(props.hauls.haulList)
    }
  }, [props.hauls.loading, props.hauls.haulList, searchValue, searchedValue])

  useEffect(() => {
    if (props.match.params.projectNumber && props.hauls.haulsList) {
      const { projectNumber } = props.match.params
      // let searchList = []
      let haulList = props.hauls.haulList.filter(
        haul => haul.project.projectNumber.toLowerCase() === projectNumber.toLowerCase()
      )
      let project = props.projectList.find(project => project.projectNumber === projectNumber)
      setSearchValue(project.projectName)
      setSearchedValue(project.projectName)
      setSearchFilter(true)
      setHaulsList(haulList)
    } else {
      // getHauls()
    }
  }, [props.hauls.haulsList, props.match.params.projectNumber]) //eslint-disable-line

  useEffect(() => {
    const { activeHauls } = props
    let hauls = props.hauls.haulList
    if (activeHauls && activeHauls.length > 0) {
      activeHauls.forEach(haulId => {
        hauls.forEach((item, i) => {
          if (item.haulId === haulId) {
            hauls.splice(i, 1)
            hauls.unshift(item)
          }
        })
      })
    }
    setHaulsList(hauls)
  }, [props, props.hauls.haulList])

  return (
    <MainContainer>
      <TableContainer>
        <TableTopSection
          title="Hauls"
          loading={props.hauls.loading}
          searchString={
            !props.hauls.loading ? (
              <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
                {!searchFilter &&
                  haulsList &&
                  searchedValue.length === 0 &&
                  `${haulsList.length} Hauls`}
                {!haulsList && `0 Hauls`}
                {searchFilter &&
                  `${haulsList.length} ${
                    haulsList.length > 1 ? 'Hauls' : 'Haul'
                  } found for '${searchedValue}'`}
              </p>
            ) : (
              undefined
            )
          }
          searchSubmit={e => search(e)}
          searchXButtonPress={clearSearch}
          searchValue={searchValue}
          setSearchValue={v => setSearchValue(v)}
          handlePlusIconClick={() => createOrEditHaulModalToggle('new')}
          additionalElement={
            props.companyFeatures.includes('materials') && (
              <div style={{ marginLeft: 'auto' }}>
                <div className="tooltip">
                  <TerrainIcon
                    className="downloadBtnRight actionsIcon"
                    onClick={props.toggleMaterialsModal}
                  />
                  <span className="tooltiptext" style={{ fontSize: '0.875rem' }}>
                    Materials
                  </span>
                </div>
              </div>
            )
          }
        />

        <TableSection>
          <thead>
            <tr>
              {['HAUL ID', 'MATERIAL', 'PICK-UP SITE', 'DROP-OFF SITE', ''].map(item => (
                <TableHeader title={item} key={item} />
              ))}
            </tr>
          </thead>
          <tbody>
            {!props.hauls.loading && haulsList && haulsList.length > 0 ? (
              // eslint-disable-next-line
              haulsList.map((haul, index) => {
                return (
                  <HaulItem
                    haul={haul}
                    haulDetailModalToggle={haulDetailModalToggle}
                    uploadBackupModalToggle={uploadBackupModalToggle}
                    history={props.history}
                    key={haul._id}
                    index={index}
                    materialsList={props.materialsList}
                    companyId={props.companyId}
                  />
                )
              })
            ) : (
              <tr></tr>
            )}
          </tbody>
        </TableSection>
      </TableContainer>

      {uploadBackupModal && (
        <UploadBackupModal
          uploadBackupModalToggle={uploadBackupModalToggle}
          fileChangeDrop={fileChangeDrop}
          uploadPitSlip={uploadPitSlip}
          fileStatusChange={fileStatusChange}
          _id={uploadBackupHaulId}
        />
      )}

      {createOrEditHaulModal && (
        <CreateOrEditHaul
          siteList={props.siteList}
          projectList={props.projectList}
          contactList={props.contactList}
          createOrEditHaulModalToggle={createOrEditHaulModalToggle}
          haulDetailModalToggle={haulDetailModalToggle}
          materialList={props.materialsList}
          haulDetail={currentHaul}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          createNewHaul={createNewHaul}
          editHaul={editHaul}
          viewStep={viewStep}
          showConfirmEditModal={showConfirmEditModal}
          isProcoreAvailable={props.companyFeatures.includes('procore')}
          procoreCostCodes={procoreCostCodes}
        />
      )}
      {viewHaulModal && (
        <ViewHaul
          siteList={props.siteList}
          projectList={props.projectList}
          contactList={props.contactList}
          haulDetailModalToggle={haulDetailModalToggle}
          createOrEditHaulModalToggle={createOrEditHaulModalToggle}
          materialList={props.materialsList}
          haulDetail={currentHaul}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          viewStep={viewStep}
          setViewStep={setViewStep}
          companyId={props.companyId}
          isProcoreAvailable={props.companyFeatures.includes('procore')}
        />
      )}
      {pitslipActionModal && <Snackbar text="Uploaded Successfully" />}
      {props.snackBarVisible && <Snackbar text="New Haul Created" />}
      {confirmModal && (
        <SmConfirmModal
          heading="Save Changes"
          text="Press OK to confirm changes or Cancel to keep editing"
          onCloseClick={confirmModalToggle}
          onOKClick={handleSubmit}
        />
      )}
      {props.materialsModal && (
        <MaterialsModal
          materials={props.materialsList}
          materialsModalToggle={props.toggleMaterialsModal}
          getMaterials={props.getMaterials}
        />
      )}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    hauls: state.hauls,
    materialsList: state.materials.materialList,
    contactList: state.contacts.contactList,
    projectList: state.projects.projectList,
    siteList: state.sites.siteList,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    activeHauls: state.activeNow.hauls,
    materialsModal: state.materials.materialsModal,
    companyFeatures: state.user.userData.companyFeatures,
    companyId: state.user.userData.companyId,
    procore: state.companies.company.procore
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getHauls,
      createNewHaul,
      editHaul,
      setSnackBarCopy,
      toggleSnackBar,
      getMaterials,
      toggleMaterialsModal,
      getToken
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Hauls)
